import { cmxReducerFactory } from '../reducer-utils';
import * as UIActions from '../../actions/ui';
import {
  bpmTasksAvailable,
  caseDetailAvailable,
  activeProcessId,
  getBPMDetails,
  ignoreEvidence
} from '../../actions/bpm-steps.action';
import { setActiveCaseRun } from '../cases/process-id-selection';
import { bpmSteps, caseUtils } from '@codametrix/ui-common';

export const InitialState = {
  stages: [],
  loading: true,
  locked: false,
  activeCase: {} as CMxAPI.Case,
  activeCaseRun: {} as CMxAPI.CaseRun,
  evidence: {},
  showRawJSON: false
};

function handleDefault(state: any) {
  return { ...state };
}

const reducer = cmxReducerFactory<CMx.BPMStepsState>(InitialState)
  .case(bpmTasksAvailable, (state, fullEvidence) => {
    const { activeCaseRun } = state;
    const stages = bpmSteps.stepsToStages(
      fullEvidence[activeCaseRun.process_instance_id]
    );
    return {
      ...state,
      stages,
      evidence: fullEvidence
    };
  })
  .case(UIActions.parentDidNavigate, (state, didNavigate) => {
    return { ...state, locked: !didNavigate };
  })
  .case(caseDetailAvailable, (state, caseAndProcessId) => {
    const { caseDetail, processId } = caseAndProcessId;
    const activeCaseRun = caseUtils.getCaseRun(caseDetail, processId);
    return {
      ...state,
      activeCase: caseDetail,
      activeCaseRun
    };
  })
  .case(getBPMDetails.async.started, (state, ids) => {
    return {
      ...state,
      loading: true
    };
  })
  .case(getBPMDetails.async.done, (state, result) => {
    return {
      ...state,
      loading: false
    };
  })
  .case(activeProcessId, (state, processId) => {
    const { activeCase, activeCaseRun, evidence } = state;
    const newActiveCaseRun =
      setActiveCaseRun(activeCase.caseRuns, processId) ?? activeCaseRun;
    const stages = bpmSteps.stepsToStages(evidence[processId]);
    return {
      ...state,
      stages,
      activeCaseRun: newActiveCaseRun
    };
  })
  .case(ignoreEvidence, (state, value) => {
    return {
      ...state,
      showRawJSON: value
    };
  })
  .default(handleDefault);

export default reducer;
